import { render, staticRenderFns } from "./modalEditarDatosPedido.vue?vue&type=template&id=813df65a&scoped=true"
import script from "./modalEditarDatosPedido.vue?vue&type=script&lang=js"
export * from "./modalEditarDatosPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813df65a",
  null
  
)

export default component.exports